interface BulletListProps {
  items: string[];
}

export const BulletList = ({ items }: BulletListProps) => (
  <ul className="list-disc space-y-2 pl-6">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);
